export const attributesProductSelectionTitles = {
    SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_ATTRIBUTE: "Select attributes",
    SELECT_PRODUCTS_BASED_ON_HAVE_ATTRIBUTE: "Select attributes",
    SELECT_PRODUCTS_BASED_ON_HAVE_TAG: "Has a specific tag",
    SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_TAG: "Does not have a specific tag",
    SELECT_PRODUCTS_BASED_ON_MULTIPLE_CONDITIONS: "Multiple conditions",
};
